import { ContactName } from '@testout/testout-commerce/models/ContactName';
import { Email } from '@testout/testout-commerce/models/Email';
import { msalInstance } from "./index";

export default class Employee {

    employeeNumber: string;
    name: ContactName;
    email: Email;

    constructor(employeeNumber: string, name: string, email: string) {
        this.employeeNumber = employeeNumber;
        this.name = new ContactName(name);
        this.email = new Email(email, name);
    }

    static get current(): Employee | null {
    let email = msalInstance.getActiveAccount()?.username ?? "";
        let employeeNumber = email.substring(0, email.indexOf("@")).toUpperCase();
        // This list of exceptions needs to also be maintained in Commerce Sales at WebhookController.cs (line 120+) and Commerce Server at System.cs (line 444+)
        if (employeeNumber === "WEDWARDS") employeeNumber = "WLE";
        else if (employeeNumber === "CRUSSON") employeeNumber = "CRR";
        else if (employeeNumber === "ABARNETT") employeeNumber = "JAB";
        else if (employeeNumber === "SGEORGE") employeeNumber = "SJG";
        else if (employeeNumber === "JHKNUDSEN") employeeNumber = "JHK";
        else if (employeeNumber === "JKNUDSEN") employeeNumber = "JHK";
        else if (employeeNumber === "KENT.MAHONEY") employeeNumber = "KMAHONEY";
        else if (employeeNumber === "KENT.LUTZ") employeeNumber = "KLUTZ";
        else if (employeeNumber === "KAREN.MARTIN") employeeNumber = "KMARTIN";
        if (employeeNumber === "") employeeNumber = "";
    return new Employee(employeeNumber, msalInstance.getActiveAccount()?.name ?? "", email);
    }
}